import React from "react";
import { CancelBookingRendererGateway } from "../components/scheduling-link/CancelBookingRendererGateway";

export function LinkCancelPage() {
  return <CancelBookingRendererGateway />;
}
